import React from 'react';
import Button from './Button';

export default (props) => (
  <Button
    {...props}
    defaultStyle={{ padding: '12px', paddingBottom: '6px', display: 'block', lineHeight: '20px', background: '#363636', color: 'white' }}
    hoverStyle={{ background: '#00a9a7' }}
  >
    {props.children}
  </Button>
)


// WEBPACK FOOTER //
// ./src/components/IconButton.js